// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"182":"daybook-no-entry","309":"daybook-entry"}[chunkId] || chunkId) + "." + {"182":"92947d47","309":"777eb928","512":"e1378e6f","534":"0c94d8b6","538":"4380c56f"}[chunkId] + ".css";
};